module.exports = __webpack_public_path__ + "static/media/swatches.2f1c23e9.svg";